<template>
    <div class="container h-100">
        <div class="adiman"></div>
        <div class="row align-items-center h-100">
            <div class="col-12 text-center mx-auto">
                <a class="btn btn-primary btn-lg text-white mb-auto loginWithGoogle" @click="signInWithGoogle"><i
                        class="fab fa-google"></i> Prijavi se z Google računom</a>
            </div>
        </div>
    </div>
</template>

<script>
  import firebase from 'firebase'
  import {db} from '../main'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    name: 'login',
    components: {
      Loading
    },
    data: function () {
      return {
        email: '',
        password: '',
        isLoading: false
      }
    },
    beforeCreate: function () {
      document.body.className = 'login'
    },
    destroyed: function () {
      document.body.className = ''
    },
    methods: {
      login () {
        const _this = this

        _this.isLoading = true

        firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
          .then(function () {
            // Existing and future Auth states are now persisted in the current
            // session only. Closing the window would clear any existing state even
            // if a user forgets to sign out.
            // ...
            // New sign-in will be persisted with session persistence.
            return firebase.auth().signInWithEmailAndPassword(_this.email, _this.password).then(function (res) {
              _this.setLoggedUserData(res)
            })
          })
          .catch(function (error) {
            // Handle Errors here.
            let errorCode = error.code
            let errorMessage = error.message
            _this.isLoading = false
            console.error(errorCode, errorMessage)
          })
      },
      signInWithGoogle () {
        const _this = this

        const provider = new firebase.auth.GoogleAuthProvider()

        firebase.auth().signInWithPopup(provider).then((res) => {
          console.log('res', res)

          if (res.user.email.split('@')[1] === 'dobra-pot.si') {
            _this.setLoggedUserData(res)
          } else {
            _this.$swal('Napaka', 'Poskušate se prijaviti z neveljavnim uporabniškim računom!', 'error', {dangerMode: true})
          }

        }).catch((error) => {
          console.error('error', error)
        })
      },
      setLoggedUserData (userResp) {
        const _this = this

        const users = db.collection('users')
        console.log('userResp', userResp)

        users.where('email', '==', userResp.user.email)
          .get()
          .then(function (querySnapshot) {

              querySnapshot.forEach(function (doc) {

                console.log('doc', doc)

                let userData = doc.data()
                console.log('userData', userData)

                let userSessionData = {
                  email: userData.email,
                  first_name: userData.first_name,
                  last_name: userData.last_name,
                  photo: userData.photo,
                  id: userData.id,
                  role: userData.role,
                  administrator: userData.administrator,
                  isEmployed: userData.isEmployed,
                  userTokeName: 'firebase:authUser:' + userResp.user.l + ':' + userResp.user.m
                }

                _this.$store.dispatch('setCurrentlySelectedUser', userData.id);
                _this.$store.dispatch('setCurrentlySelectedYear', _this.moment().year());
                _this.$store.dispatch('setCurrentlySelectedMonth',  _this.moment().month());

                firebase.auth().currentUser.getIdToken(true).then(function (idToken) {

                  sessionStorage.setItem('DP_user', JSON.stringify(userSessionData))

                  let p1 = _this.$store.dispatch('retrieveUserDetails')
                  let p2 = _this.$store.dispatch('retrieveProjects')
                  let p3 = _this.$store.dispatch('retrieveUsers')
                  let p4 = _this.$store.dispatch('retrieveEvents')
                  let p5 = _this.$store.dispatch('retrieveRoles')

                  Promise.all([p1, p2, p3, p4, p5]).then((values) => {
                    _this.isLoading = false
                    console.log("HERE!");
                    if (userData.administrator) {
                      console.log("HERE2!");
                      _this.$router.replace('/dogodki')
                    } else {
                      console.log("HERE3!");
                      _this.$router.replace('/dogodki')
                    }
                  })

                }).catch(function (error) {
                  console.error('Could not retrieve current user\'s token!')
                })
              })
            }
          )
          .catch(function (error) {
            console.log('Error getting documents: ', error)
          })

      }
    }
    // methods: {
    //   login () {
    //     const _this = this
    //
    //     _this.isLoading = true;
    //
    //     firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
    //       .then(function () {
    //         // Existing and future Auth states are now persisted in the current
    //         // session only. Closing the window would clear any existing state even
    //         // if a user forgets to sign out.
    //         // ...
    //         // New sign-in will be persisted with session persistence.
    //         return firebase.auth().signInWithEmailAndPassword(_this.email, _this.password).then(function (res) {
    //           _this.setLoggedUserData(res)
    //         })
    //       })
    //       .catch(function (error) {
    //         // Handle Errors here.
    //         let errorCode = error.code
    //         let errorMessage = error.message
    //         _this.isLoading = false
    //         console.error(errorCode, errorMessage)
    //       })
    //   },
    //   setLoggedUserData (userResp) {
    //     const _this = this
    //
    //     const users = db.collection('users')
    //     console.log('userResp', userResp)
    //
    //     users.where('email', '==', userResp.user.email)
    //       .get()
    //       .then(function (querySnapshot) {
    //
    //         querySnapshot.forEach(function (doc) {
    //
    //           console.log('doc', doc)
    //
    //           let userData = doc.data()
    //           console.log('userData', userData)
    //
    //           let userSessionData = {
    //             email: userData.email,
    //             first_name: userData.first_name,
    //             last_name: userData.last_name,
    //             photo: userData.photo,
    //             id: userData.id,
    //             role: userData.role,
    //             administrator: userData.administrator,
    //             userTokeName: 'firebase:authUser:' + userResp.user.l + ':' + userResp.user.m
    //           }
    //
    //           firebase.auth().currentUser.getIdToken(true).then(function (idToken) {
    //
    //             sessionStorage.setItem('DP_user', JSON.stringify(userSessionData))
    //
    //             let p1 = _this.$store.dispatch('retrieveUserDetails')
    //             let p2 = _this.$store.dispatch('retrieveProjects')
    //             let p3 =_this.$store.dispatch('retrieveUsers')
    //             let p4 =_this.$store.dispatch('retrieveEvents')
    //             let p5 =_this.$store.dispatch('retrieveRoles')
    //
    //             Promise.all([p1, p2, p3, p4, p5]).then((values) => {
    //               _this.isLoading = false;
    //               _this.$router.replace('/dogodki')
    //             });
    //
    //           }).catch(function (error) {
    //             console.error('Could not retireve current user\'s token!')
    //           })
    //         })
    //       })
    //       .catch(function (error) {
    //         console.log('Error getting documents: ', error)
    //       })
    //
    //   }
    // }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Login.vue